import { DataType } from "../services/CompanyService";

export function sanitizeAdditionalValue(value: string, type: DataType): string {
  if (value === "") return "";
  switch (type) {
    case DataType.Number:
    case DataType.Currency:
      return isNaN(Number(value)) ? "" : value;
    case DataType.Date:
      return isNaN(Date.parse(value)) ? "" : value;
    case DataType.List:
      return isNaN(parseInt(value, 10)) ? "" : value;
    default:
      return value;
  }
}
